import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { ACCOUNT_LIST_REPORT_ID } from './accountListReportId';

export const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.ACCOUNT_ID.field,
    FIELDS.ACCOUNT_NAME_ID.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.ACCOUNT_TYPE.field,
    FIELDS.CURRENCY.field,
    FIELDS.TIME_ZONE_NAME.field,
    FIELDS.ACCOUNT_LANGUAGE.field,
    FIELDS.ACCOUNT_COUNTRY.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(ACCOUNT_LIST_REPORT_ID, field));
